import axios from "axios";
import { NGROK } from "../../../../APIs";

export interface BloodHoundQuery {
  id?: number;
  description: string;
  query: string;
  includeProperties?: boolean;
}

export interface ADNodeData {
  label: string;
  kind: string;
  objectId: string;
  isTierZero: boolean;
  isOwnedObject: boolean;
  lastSeen: string;
  properties: Record<string, any>;
}

export interface ADEdgeData {
  source: string;
  target: string;
  label: string;
  kind: string;
  lastSeen: string;
  properties: Record<string, any>;
}

export interface BloodHoundQueryResponse {
  data: {
    nodes: Record<string, ADNodeData>;
    edges: ADEdgeData[];
  };
}

export interface TenantData {
  tenantName: string;
  [key: string]: any;
}

// ============= API Calls =============

export const fetchTenants = async (): Promise<TenantData[]> => {
  const response = await axios.get(`${NGROK}/api/get-all-domains`, {

  });
  return response.data || [];
};

export const fetchBloodHoundQueries = async (tenantName: string): Promise<BloodHoundQuery[]> => {
  const response = await axios.get(
    `${NGROK}/api/bloodhound/query/get-all`,
    {

      params: { tenantName },
    }
  );
  return response.data || [];
};

export const runBloodHoundQuery = async (
  cypherQuery: string,
  tenantName: string,
  includeProperties?: boolean
): Promise<BloodHoundQueryResponse> => {
  const response = await axios.post(
    `${NGROK}/api/bloodhound/query/run`,
    { cypherQuery, includeProperties, tenantName },
  );
  return response.data;
};
